export const hasValidDni = (optionalDni, patientDni) => {
  return !optionalDni && patientDni?.length === 15
}
